import React from "react";

export default function PageHeader({ eyebrow, title, description, actions }) {
  return (
    <div className="border-b border-zinc-200 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-8 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
        <div>
          {eyebrow && <div className="data-label mb-2">{eyebrow}</div>}
          <h1 className="font-display text-3xl sm:text-4xl tracking-tighter font-bold uppercase">
            {title}
          </h1>
          {description && <p className="text-sm text-zinc-600 mt-2 max-w-2xl">{description}</p>}
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
    </div>
  );
}
